<template>
    <div class="update-text" v-if="showUpdated">
        <p class="detail-content">
            <template v-if="showUpdateAndDay">
                <span>{{ $t('md-detail-info.updated') }}</span
                ><span class="day-site">{{ updatedTime }}</span>
            </template>
            <span class="tiny-site">
                <only-client>{{ createTime() }}</only-client>
            </span>
        </p>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import { dateFormat } from '@/common/format';
import { INTERCEPT_MLS } from '@/common/customize.js';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {
            updatedTime: ''
        };
    },
    inject: ['createTime'],
    props: {},
    mounted() {
        if (this.info.updateTimeLong) {
            this.updatedTime = dateFormat(
                'MM/dd/yyyy hh:mm p',
                new Date(this.info.updateTimeLong),
                this.$pinia
            ); 
        }
    },
    computed: {
        ...mapState({
            'info': store => store.listingDetail.info || {}
        }),
        showUpdated() {
            return (
                this.info.updateTimeLong != null ||
                this.info.createTimeLong != null ||
                this.info.chimeFirstInserted != null
            );
        },
        showUpdateAndDay({ info }) {
            //CHIME-21882
            return !INTERCEPT_MLS.hiddenUpdateTime.includes(info?.mlsOrg?.id || 0);
        }
    }
};
</script>
<style lang="scss">
.update-text {
    margin-top: 10px;
    font: 14px var(--font-normal);
    color: #a8a8a8;
    .day-site {
        padding-right: 1em;
    }
}
</style>
